import React, { useState } from "react";
import { useHistory } from 'react-router-dom'

// reactstrap components
import {
  Button,
  Input,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import Navbar from "components/Navbars/Navbar.js";
import TransparentFooter from "components/Footers/TransparentFooter.js";
import PageHeader from "components/PageHeader";
import Pagination from 'rc-pagination';
import './index.scss'
import './pagination.less'

import { getTopMeetingActivity, getRecentMeeting, getListMeetingActivity } from '../../../api/api.js'
import { countDown } from '../../../utils/utils.js'
import searchIcon from 'assets/img/paper/search.png'
import bgImg from 'assets/images/showcase-bg.jpg'
import clock from 'assets/images/clock.png'


function MeetingAndActivityPage() {
  const [headerSolgan, setHeaderSolgan] = useState({title: '学习园地', solgan: '分享最新研究成果 共建优质科研平台', bgImg, position: '25%'})
  const [lastestList, setLastestList] = useState([])
  const [topMeetingList, setTopMeetingList] = useState([])
  const [meetingList, setMeetingList] = useState([])
  const [meetingList1, setMeetingList1] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [current, setCurrent] = useState(1)
  const [pageSize, setPageSize] = useState(9)
  const [total, setTotal] = useState(0)
  const history = useHistory()
  React.useEffect(() => {
    document.body.classList.add("login-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    function setScale() {
      let scale = window.innerWidth/1920
      let height = 1920/window.innerWidth * 100 + 'vh'
      document.querySelector('#root').style.zoom = scale //`scale(${scale})`
      document.querySelector('#root .auto-height').style.minHeight = `calc(${height} - 510px)`
    }
    setScale()
    window.onresize = function() {
      setScale()
    }
    getTopMeetingActivityData()
    getRecentMeetingList()
    getListMeetingActivityData()
    getListMeetingActivityData1()
    return function cleanup() {
      document.body.classList.remove("login-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  //获取置顶
  const getTopMeetingActivityData = async () => {
    let res = await getTopMeetingActivity()
    if(res.code == 0) {
      setTopMeetingList(res.rows)
    }
  }

  //最近更新
  const getRecentMeetingList = async (pageNum) => {
    let params = {
      pageSize: pageSize,
      pageNum: pageNum?pageNum:current,
      title: searchValue
    }
    let res = await getRecentMeeting(params)
    if(res.code == 0) {
      setLastestList(res.rows)
      setTotal(res.total)
    }
  }

  // 获取更多动态
  const getListMeetingActivityData = async () => {
    let params = {
      activityKind: 1
    }
    let res = await getListMeetingActivity(params)
    if(res.code == 0) {
      setMeetingList(res.rows)
    }
  }

  // 获取更多动态
  const getListMeetingActivityData1 = async () => {
    let params = {
      activityKind: 2
    }
    let res = await getListMeetingActivity(params)
    if(res.code == 0) {
      setMeetingList1(res.rows)
    }
  }

  //搜索框输入
  const handleSetValue = (e) => {
    setSearchValue(e.target.value)
  }

  const handleKeyUp = (e) => {
    if(e.keyCode == 13) {
      handleSearch()
    }
  }
  
  // 跳转搜索
  const handleSearch = () => {
    console.log(searchValue)
    setCurrent(1)
    getRecentMeetingList(1)
  }

  // 翻页
  const onChange = (page) => {
    setCurrent(page)
    getRecentMeetingList(page)
  }

  // 跳转详情
  const handleDetail = (item, type) => {
    let url = ''
    if(type == 'live') {
      url = `/videoDetail?id=${item.id}&type=3`
    }else {
      if(item.detailId) {
        if(item.activityKind == 1) {
          url = `/videoDetail?id=${item.detailId}&type=3`
        }else {
          url = `/activitydetail?id=${item.detailId}&type=3`
        }
      }else {
        url = `/meetingTheme?id=${item.id}&title=${item.themeName}`
      }
    }
    // if(item.activityKind == 1) {
    //   url = `/videoDetail?id=${item.id}&type=3`
    // }else {
    //   url = `/activitydetail?id=${item.id}&type=3`
    // }
    history.push(url)
  }

  return (
    <div className="meeting-activity-wapper">
      <Navbar />
      <PageHeader headerSolgan={headerSolgan}></PageHeader>
      <div className="meeting-activity-main auto-height">
        <Container>
          <div className="live-wapper">
            {
              topMeetingList[0]?
              <div className="live-big" onClick={() => handleDetail(topMeetingList[0], 'live')}>
                {
                  topMeetingList[0].liveStatus == 1?<span className="tag">正在直播</span>:null
                }
                <img src={topMeetingList[0].thumbnailUrl} alt="" />
                {
                  topMeetingList[0].liveStatus != 1?<span className="tips">{topMeetingList[0].liveStatus == 0?`距离开始：${countDown(topMeetingList[0].startTime)}`:'已结束'}</span>:null
                }
              </div>:null
            }
            <div className="live-small">
              {
                topMeetingList.map((topMeeting,index) => (
                  <>
                    {
                      index != 0 && index < 3?
                      <div className="live-small-item" key={index} onClick={() => handleDetail(topMeeting, 'live')}>
                        <span className="tag">正在直播</span>
                        <img src={topMeeting.thumbnailUrl} alt="" />
                        {
                          topMeeting.liveStatus != 1?<span className="tips">{topMeeting.liveStatus == 0?`距离开始：${countDown(topMeeting.startTime)}`:'已结束'}</span>:''
                        }
                      </div>:null
                    }
                  </>
                ))
              }
            </div>
          </div>
          <div className="meeting-activity-lastest">
            <div className="lastest-header">
              <div className="lastest-title">最近更新</div>
              {
                /**
                 * <div className="search">
                    <Input placeholder="请输入查询关键字" onChange={(e) => handleSetValue(e)} onKeyUp={(e) => handleKeyUp(e)} />
                    <img src={searchIcon} alt="" onClick={() => handleSearch()} />
                  </div>
                 */
              }
            </div>
            <div className="lastest-content">
              {
                lastestList.map((lastest, index) => (
                  <div md="4" style={{margin: `${(index+2)%3==0?'0 30px 40px':'0 0 40px'}`}} key={`lastest${index}`} onClick={() => handleDetail(lastest, 'recent')}>
                    <div style={{width: '100%', position: 'absolute', top: 0,}}>
                      <div className="lastest-img">
                        <img src={lastest.picUrl} alt="" />
                        {
                          lastest.isMemberExclusive == 1?<span className="tips">会员</span>:null
                        }
                      </div>
                    </div>
                    <div className="lastest-item">
                      <div className="publish-name">
                        <span>{lastest.themeName}</span>
                      </div>
                      <div className="publish-title">{lastest.description}</div>
                      <div className="publish-time">
                        <img src={clock} alt="" />
                        <span>{lastest.publishTime}</span>
                      </div>
                    </div>
                  </div>
                ))
              }
            </div>
            <Pagination
              onChange={onChange}
              current={current}
              pageSize={pageSize}
              total={total}
            />
            {
              /**
              <div className="more">
                <div className="line-left"></div>
                <Button color="3d8d9f">查看更多</Button>
                <div className="line-right"></div>
              </div>
               */
            }
          </div>
          <div className="more-activity">
            <div className="lastest-title">更多动态</div>
            <Row style={{marginBottom: '40px'}}>
              <Col md="6">
                <ul className="meeting-activity-content-list">
                  {
                    meetingList.map(meeting => (
                      <li className="meeting-activity-item" key={meeting.id} style={{ paddingRight: '20px', marginTop: '20px'}} onClick={() => handleDetail(meeting, 'live')}>
                        <div className="meeting-activity-item-desc">
                          <span className="label meeting-label">{meeting.activityKind == 1?'直播回放':meeting.activityKind == 2?'联盟活动':'联盟会议'}</span>
                          <p>{meeting.title}</p>
                        </div>
                        <div className="meeting-activity-item-time">{meeting.publishTime && meeting.publishTime.split(' ')[0]}</div>
                      </li>
                    ))
                  }
                </ul>
              </Col>
              <Col md="6">
                <ul className="meeting-activity-content-list">
                  {
                    meetingList1.map((meeting) => (
                      <li className="meeting-activity-item" key={meeting.id} style={{ paddingRight: '20px', marginTop: '20px'}} onClick={() => handleDetail(meeting, 'live')}>
                        <div className="meeting-activity-item-desc">
                          <span className="label activity-label">{meeting.activityKind == 1?'直播回放':meeting.activityKind == 2?'联盟活动':'联盟会议'}</span>
                          <p>{meeting.title}</p>
                        </div>
                        <div className="meeting-activity-item-time">{meeting.publishTime && meeting.publishTime.split(' ')[0]}</div>
                      </li>
                    ))
                  }
                </ul>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <TransparentFooter />
    </div>
  );
}

export default MeetingAndActivityPage;
